import { Row, flexRender } from '@tanstack/react-table';

import React from 'react';
import clsx from 'clsx';
import styles from '../data-table.module.scss';

interface Props<TData> {
    row: Row<TData>;
    isHighlighted: boolean;
}

const DataTableBodyRow = <TData,>({ row, isHighlighted }: Props<TData>) => {
    const isSelected = row.getIsSelected();

    const rowClasses = clsx(styles.row, {
        [styles.rowSelected]: isSelected,
        [styles.rowHighlighted]: isHighlighted,
    });

    const visibleCells = row.getVisibleCells();

    return (
        <tr data-testid={`tbody-row-${row.id}`} className={rowClasses} aria-selected={isSelected}>
            {visibleCells.map((cell) => {
                const columnMeta = cell.column.columnDef.meta;
                const width = cell.column.columnDef.size !== -1 ? cell.column.getSize() : undefined;

                return (
                    <td key={cell.id} style={{ width, ...columnMeta?.style }} className={columnMeta?.className}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                    </td>
                );
            })}
        </tr>
    );
};

export default DataTableBodyRow;
